import { ref, onMounted, onUnmounted } from 'vue';

export function useDeviceInfo() {
  const isMobile = ref(false);
  const isIOS = ref(false);
  const isAndroid = ref(false);
  const isWechat = ref(false);
  const isPortrait = ref(true);
  
  const checkDevice = () => {
    const ua = navigator.userAgent;
    isMobile.value = /Mobile|Android|iPhone/i.test(ua);
    isIOS.value = /iPhone|iPad|iPod/i.test(ua);
    isAndroid.value = /Android/i.test(ua);
    isWechat.value = /MicroMessenger/i.test(ua);
    isPortrait.value = window.innerHeight > window.innerWidth;
  };
  
  const handleResize = () => {
    isPortrait.value = window.innerHeight > window.innerWidth;
  };
  
  onMounted(() => {
    checkDevice();
    window.addEventListener('resize', handleResize);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });
  
  return {
    isMobile,
    isIOS,
    isAndroid,
    isWechat,
    isPortrait,
  };
} 